/**
 * CollectionArticlesPage - Página de listagem de artigos filtrados por coleção
 *
 * TRANSFORMER PATTERN:
 * Esta página usa ArticleListPageTemplate com filtro por coleção.
 * - baseFilter: { collectionId } (artigos da coleção específica)
 * - pageTitle: "Artigos da Coleção"
 * - pageConfig: { showScraping: false, showBackgroundScraping: false, showCollectionHeader: true }
 *
 * Funciona para ambos tipos de coleção:
 * - Coleção de Tags: Backend busca artigos que têm qualquer uma das tags da coleção
 * - Coleção de Artigos: Backend busca artigos pelo ID direto
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import ArticleListPageTemplate from '../../components/templates/ArticleListPageTemplate/ArticleListPageTemplate';

const CollectionArticlesPage = () => {
  const { collectionId } = useParams();

  return (
    <ArticleListPageTemplate
      pageTitle="Artigos da Coleção"
      baseFilter={{ collectionId }}
      pageConfig={{
        showScraping: false,
        showBackgroundScraping: false,
        showCollectionHeader: true
      }}
    />
  );
};

export default CollectionArticlesPage;
